export const servicePermissions = {
  read: 'service-1',
  create: 'service-2',
  update: 'service-3',
  delete: 'service-4',
}

export const salesPermissions = {
  read: 'sales-1',
  create: 'sales-2',
  update: 'sales-3',
  delete: 'sales-4',
}

export const reportPermissions = {
  read: 'report-1',
  update: 'report-3',
}
export const commissionTipsPermissions = {
  read: 'commissionTips-1',
  update: 'commissionTips-3',
}

export const clientPermissions = {
  read: 'client-1',
  create: 'client-2',
  update: 'client-3',
  delete: 'client-4',
}

export const billingPermissions = {
  read: 'billing-1',
}

export const settingPermissions = {
  read: 'setting-1',
  update: 'setting-3',
}

export const userPermissions = {
  read: 'user-1',
  create: 'user-2',
  update: 'user-3',
  delete: 'user-4',
}
export const rolePermissions = {
  read: 'role-1',
  create: 'role-2',
  update: 'role-3',
  delete: 'role-4',
}

export const schedulePermissions = {
  read: 'schedule-1',
  create: 'schedule-2',
  delete: 'schedule-4',
}

export const packagePermissions = {
  read: 'package-1',
  create: 'package-2',
  update: 'package-3',
  delete: 'package-4',
}
export const productPermissions = {
  read: 'product-1',
  create: 'product-2',
  update: 'product-3',
  delete: 'product-4',
}
export const dealPermissions = {
  read: 'deal-1',
  create: 'deal-2',
  update: 'deal-3',
  delete: 'deal-4',
}

export const notificationPermissions = {
  read: 'notification-1',
  create: 'notification-2',
  update: 'notification-3',
  delete: 'notification-4',
}

export const paymentPermissions = {
  read: 'payment-1',
}

export const expensesPermissions = {
  read: 'expenses-1',
  create: 'expenses-2',
  update: 'expenses-3',
  delete: 'expenses-4',
}

export const attendancesPermissions = {
  read: 'attendance-1',
  create: 'attendance-2',
  delete: 'attendance-4',
}

export const voucherPermissions = {
  read: 'voucher-1',
  create: 'voucher-2',
  update: 'voucher-3',
}
